import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getMySchedules = api(async function getMySchedules({
    drafts,
    published,
    skip,
    limit,
    search,
    sortMode,
    retired,
    Red,
    Amber,
    Pink,
    Green,
}) {
    return query(
        gql`
            query getSchedules(
                $drafts: Boolean
                $published: Boolean
                $limit: Int
                $skip: Int
                $search: String
                $retired: Boolean
                $sortMode: MyScheduleSortMode
                $Red: Boolean
                $Green: Boolean
                $Amber: Boolean
                $Pink: Boolean
            ) {
                getMySchedules(
                    drafts: $drafts
                    published: $published
                    skip: $skip
                    limit: $limit
                    search: $search
                    sortMode: $sortMode
                    retired: $retired
                    Red: $Red
                    Green: $Green
                    Amber: $Amber
                    Pink: $Pink
                ) {
                    count
                    scheduleItems {
                        title
                        _id
                        itemType
                        taskTypes {
                            Red
                            Pink
                            Amber
                            Green
                        }
                        code
                        owner
                        lastModifiedBy
                        modified
                        version
                    }
                }
            }
        `,
        { drafts, published, skip, limit, search, sortMode, retired, Red, Pink, Amber, Green },
        { returns: "getMySchedules" }
    )
})
